export const mapFieldToDisplay = {
  moves: 'Moves',
  moveCountCriticalPercentage: 'Threshold L3',
  moveCountStretchPercentage: 'Threshold L2',
  yardCapacity: 'YardCapacity',
  reeferPlugs: 'Reefer Plugs',
  imoUnits: 'IMO Units',
  oogUnits: 'OOG Units',
  imoUnitsDescription: 'IMO Units Description',
  override: 'Restored to default values',
  overrideOCL: 'Automatically updated (new period)',
  vesselPairLimits: 'Vessel pair limits',
  maxCapacity: 'Max TEU Capacity',
  ladenCapacity: 'Laden TEUs',
  emptyCapacity: 'Empty TEUs',
};
